import { MeetingRoom } from '@virtual-care/ui';

export default function GuestMeeting() {
  return <MeetingRoom navigationPath="/join/ended" />;
}
